








































import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import Translation from '@/mixins/Translation'
import TabsMenu from '@/components/TabsMenu.vue'
import NeedTransferTabPanel from '@/pages/received-invoices/tab-panel/NeedTransfer.vue'
import AlreadyTransferTabPanel from '@/pages/received-invoices/tab-panel/AlreadyTransfer.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'

const layout = namespace('layout')
const gtm = namespace('gtm')

type TabName = 'need-transfer' | 'already-transfer' | ''

interface Tab {
  name: string
  activeName: TabName
}

/**
 * @displayName MainPage
 */
@Component({
  components: {
    MainLayout,
    HeaderLayout,
    TabsMenu,
    'need-transfer': NeedTransferTabPanel,
    'already-transfer': AlreadyTransferTabPanel,
  },
})
export default class ReceivedInvoicesPage extends Mixins(Translation) {

  @Prop({default: 0, type: Number}) windowScrollY: number
  @Prop({default: '', type: String}) type: TabName

  @layout.Getter('errorSize') errorSize: number
  @gtm.Action('logEventWithGroups') logEventWithGroups:
    (payload: LogEventWidthGroupsPayload) => void

  isCancelSelect: boolean = false
  activeTab: TabName = ''
  routerFrom: string | null = null
  requiredReloadList: TabName[] = []

  get tabMenus(): Tab[] {
    const {ts} = this
    return [
      {
        name: `${ts('need-transfer')}`,
        activeName: 'need-transfer',
      },
      {
        name: `${ts('completed-transfer')}`,
        activeName: 'already-transfer',
      },
    ]
  }

  @Watch('activeTab')
  __activeTab() {
    this.onClickCancel(false)
  }

  @Watch('type', {immediate: true})
  __type(value) {
    this.activeTab = value || 'need-transfer'
  }

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const {sendAmplitude, type} = vm
      vm.routerFrom = from?.path
      sendAmplitude(type, from?.path)
    })
  }

  sendAmplitude(type, fromPath) {
    this.logEventWithGroups({
      eventType: 'item_view',
      eventProperties: {
        'item_name': type === 'already-transfer' ?
          'invoices_transferred' :
          'invoices_to_transfer',
        'prev_path': fromPath,
      }
    })
  }

  onClickTab(type) {
    this.sendAmplitude(type, this.routerFrom)
  }

  onClickCancel(val) {
    this.isCancelSelect = val
  }

  setRequiredReloadList(value: TabName) {
    const requiredReloadList = this.tabMenus.filter((menu: Tab) => menu.activeName !== value)
    this.requiredReloadList = requiredReloadList.map((item) => item.activeName)
  }

  removeRequiredReloadList(value: TabName) {
    const index = this.requiredReloadList.findIndex((item) => item === value)
    this.requiredReloadList.splice(index, 1)
  }
}
